import { Component } from '@angular/core';
import { Companies } from "../../../_shared/interfaces";
import { AlertService, ContactsStoreService, IAlertType } from "../../../_shared/services";
import { Router, RouterLink } from "@angular/router";
import { ClrIconModule } from "@clr/angular";
import { ContactFormComponent } from "../contact-form/contact-form.component";
import { ClarityIcons, twoWayArrowsIcon } from "@cds/core/icon";
import { getTenantStorage } from '../../../_shared/utils/tenant-context';

import { environment as env } from "../../../../environments/environment";

@Component({
  selector: 'app-contact-add',
  standalone: true,
  imports: [
    RouterLink,
    ClrIconModule,
    ContactFormComponent
  ],
  templateUrl: './contact-add.component.html',
  styleUrl: './contact-add.component.sass'
})
export class ContactAddComponent {
  devMode: boolean;
  crmMode: boolean;

  constructor(
    private css: ContactsStoreService,
    private alertDispatcher: AlertService,
    private router: Router
  ) {
    this.devMode = env.stages.dev;
    this.crmMode = env.externalCrm;
    ClarityIcons.addIcons(twoWayArrowsIcon);
  }

  createCompany(company: Companies) {
    console.log('test ok ' + company);
    this.css.createCompany(company)
      .subscribe((data: any) => {
        const rawContactId = data?.data?.cid ?? data?.message;
        const contactId = parseInt(rawContactId?.toString() ?? '0', 10);
        if (contactId > 0) {
          if (!this.crmMode) {
            this.router.navigate(['contact/details', contactId]);
            return;
          }

          const sessionId = getTenantStorage('crm_token') ?? '';
          const staffId = parseInt(getTenantStorage('staff_id') ?? getTenantStorage('user_id') ?? '0', 10);
          if (!sessionId || !staffId) {
            this.alertDispatcher.show({
              message: 'Kontakt angelegt, aber CRM-Sync übersprungen (Token/Staff-ID fehlt).',
              clrAlertType: IAlertType.WARNING
            }, 3500);
            this.router.navigate(['contact/details', contactId]);
            return;
          }

          this.css.syncCrmContact(contactId, { session_id: sessionId, staff_id: staffId }).subscribe({
            next: () => {
              this.alertDispatcher.show({
                message: 'Kontakt angelegt und CRM-Sync ausgeführt.',
                clrAlertType: IAlertType.SUCCESS
              }, 2500);
            },
            error: () => {
              this.alertDispatcher.show({
                message: 'Kontakt angelegt, CRM-Sync fehlgeschlagen.',
                clrAlertType: IAlertType.WARNING
              }, 4000);
            },
            complete: () => {
              this.router.navigate(['contact/details', contactId]);
            }
          });
        }
      });
  }
}
